import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  AlumnoAuditoria,
  AlumnoPractica,
  InstructorData,
  AlumnoData,
  CursoAuditoria,
  CursoPractica,
  FormadorCurso,
  Estacion,
  EstadoCurso,
  EstadoPractica,
  FechaMaximaPractica,
  FechaMinimaPractica,
  InfoUsers,
  InstructorPractica,
  JornadaUsuario,
  Practica,
  PracticaAuditoria,
  PracticasCount,
  PracticaSeleccionada,
  Provincias,
  Sociedad,
  State,
  TipoPractica,
  TipoServicio,
  FiltroPractica
} from 'store/practicas/types';
import { ActionType } from 'typesafe-actions';
import ActionTypes from 'store/practicas/actionTypes';
import * as actions from 'store/practicas/actions';
import { RequestStatusTypes } from 'consts';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import {
  parseMaxDatePractice,
  parseMinDatePractice,
} from 'utils/practiceUtils';
import { ElementsPerPage } from '../../containers/Table/table.const';

export const initialState: State = {
  // Data
  cursosPractica: [] as CursoPractica[],
  formadoresCursos: [] as FormadorCurso[],
  cursoAuditoria: [] as CursoAuditoria[],
  selectedCursosAuditoria: [] as number[],
  selectedSociedadAuditoria: [] as string[],
  selectedProvinciaAuditoria: [] as string[],
  provinciasAuditoria: [] as string[],
  alumnosPractica: [] as AlumnoPractica[],
  instructorData: [] as InstructorData[],
  alumnoData: [] as AlumnoData[],
  alumnosAuditoria: [] as AlumnoAuditoria[],
  estadosCursos: [] as EstadoCurso[],
  fechaMinimaPractica: {} as FechaMinimaPractica,
  fechaMaximaPractica: {} as FechaMaximaPractica,
  practicaSeleccionada: {} as PracticaSeleccionada,
  cursosActivosJornada: [] as CursoPractica[],
  instructoresPracticas: [] as InstructorPractica[],
  infoUser: [] as InfoUsers[],
  practicasCount: {} as PracticasCount,
  practicasAuditoriaCount: 0,
  practicas: [] as Practica[],
  practicasAuditoria: [] as PracticaAuditoria[],
  todasPracticasAuditoria: [] as PracticaAuditoria[],
  estadosPractica: [] as EstadoPractica[],
  tiposServicio: [] as TipoServicio[],
  sociedades: [] as Sociedad[],
  jornadasUsuario: [] as JornadaUsuario[],
  estaciones: [] as Estacion[],
  tiposPractica: [] as TipoPractica[],
  provincias: [] as Provincias[],
  practicasList: [] as Practica[],
  filtros: [] as FiltroPractica[],
  practicasListCount: 0,
  practicasByJornadaList: [] as Practica[],
  pages: 1,
  selectedPage: 1,
  elementsPerPage: ElementsPerPage.TEN,
  // Requests statuses
  postAnularPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  postRechazarPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  postReclamarPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  postValidarPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getFilterCursoPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getFilterFormadorCursoRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getFilterAlumnoPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getEstadosCursosRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getFechaMinimaPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getFechaMaximaPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getPracticaSeleccionadaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getCursosActivosJornadaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getInstructoresPracticasRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  crearPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getPracticasCountRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getPracticasRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getPracticasByJornadaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getPracticasAuditoriaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getEstadosPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getTipoServicioRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getSociedadesRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getJornadasUsuarioRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getEstacionesRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getTiposPracticaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getProvinciasRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  getCursosAuditoriaRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  orden: '',
  ascDesc: '',
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    // Reset reducer
    case ActionTypes.RESET_STATE:
      return initialState;

    // Set reducer
    case ActionTypes.RESET_PRACTICA_SELECCIONADA:
      return {
        ...state,
        practicaSeleccionada: initialState.practicaSeleccionada,
      };
    case ActionTypes.RESET_PRACTICAS_BY_JORNADA:
      return {
        ...state,
        practicasByJornadaList: initialState.practicasByJornadaList,
      };
    case ActionTypes.SET_CURSOS_PRACTICA:
      return {
        ...state,
        cursosPractica: [...action.payload],
      };

    case ActionTypes.SET_FORMADOR_CURSO:
      return {
        ...state,
        formadoresCursos: [...action.payload],
      };

    case ActionTypes.SET_CURSOS_AUDITORIA:
      return {
        ...state,
        cursoAuditoria: action.payload,
      };
    case ActionTypes.SET_SELECTED_CURSOS_AUDITORIA:
      return {
        ...state,
        selectedCursosAuditoria: action.payload,
      };
    case ActionTypes.SET_SELECTED_SOCIEDAD_AUDITORIA:
      return {
        ...state,
        selectedSociedadAuditoria: action.payload,
      };
    case ActionTypes.SET_SELECTED_PROVINCIA_AUDITORIA:
      return {
        ...state,
        selectedProvinciaAuditoria: action.payload,
      };

    case ActionTypes.REMOVE_SELECTED_PROVINCIAS_AUDITORIA:
      return {
        ...state,
        selectedProvinciaAuditoria: [],
      };
    case ActionTypes.REMOVE_SELECTED_CURSOS_AUDITORIA:
      return {
        ...state,
        selectedCursosAuditoria: [],
      };

    case ActionTypes.REMOVE_FILTER_AUDITORIA:
      return {
        ...state,
        selectedProvinciaAuditoria: [],
        selectedSociedadAuditoria: [],
        selectedCursosAuditoria: [],

        sociedades: [],
        cursoAuditoria: [],
        provincias: [],
        provinciasAuditoria: [],
        alumnosAuditoria: [],
      };
    case ActionTypes.SET_PROVINCIAS_AUDITORIA:
      return {
        ...state,
        provinciasAuditoria: action.payload,
      };
    case ActionTypes.SET_PROVINCIAS:
      return {
        ...state,
        provincias: action.payload,
      };
    case ActionTypes.SET_PAGES:
      return {
        ...state,
        pages: action.payload,
      };
    case ActionTypes.SET_ELEMENTS_PER_PAGE:
      return {
        ...state,
        elementsPerPage: action.payload,
      };
    case ActionTypes.SET_SELECTED_PAGE:
      return {
        ...state,
        selectedPage: action.payload,
      };
    case ActionTypes.SET_ALUMNOS_AUDITORIA:
      return {
        ...state,
        alumnosAuditoria: action.payload,
      };

    case ActionTypes.SET_ALUMNOS_PRACTICA:
      return {
        ...state,
        alumnosPractica: action.payload,
      };

    case ActionTypes.SET_ESTADOS_CURSOS:
      return {
        ...state,
        estadosCursos: action.payload,
      };

    case ActionTypes.SET_FECHA_MINIMA_PRACTICA:
      return {
        ...state,
        fechaMinimaPractica: parseMinDatePractice(action.payload),
      };

    case ActionTypes.SET_FECHA_MAXIMA_PRACTICA:
      return {
        ...state,
        fechaMaximaPractica: parseMaxDatePractice(action.payload),
      };

    case ActionTypes.SET_PRACTICAS_SELECCIONADA:
      return {
        ...state,
        practicaSeleccionada: action.payload,
      };

    case ActionTypes.SET_CURSOS_ACTIVOS_JORNADA:
      return {
        ...state,
        cursosActivosJornada: action.payload,
      };

    case ActionTypes.SET_INSTRUCTORES_PRACTICAS:
      return {
        ...state,
        instructoresPracticas: action.payload,
      };
    case ActionTypes.SET_INSTRUCTORES:
      return {
        ...state,
        instructorData: action.payload,
      };
    case ActionTypes.SET_PRACTICAS_COUNT:
      return {
        ...state,
        practicasCount: action.payload,
      };

    case ActionTypes.SET_PRACTICAS_AUDITORIA_COUNT:
      return {
        ...state,
        practicasAuditoriaCount: action.payload,
      };

    case ActionTypes.SET_PRACTICAS:
      return {
        ...state,
        practicas: action.payload,
      };

    case ActionTypes.SET_PRACTICAS_BY_JORNADA:
      return {
        ...state,
        practicasByJornadaList: action.payload,
      };

    case ActionTypes.SET_PRACTICAS_AUDITORIA:
      return {
        ...state,
        practicasAuditoria: action.payload,
      };
    case ActionTypes.SET_TODAS_PRACTICAS_AUDITORIA:
      return {
        ...state,
        todasPracticasAuditoria: action.payload,
      };

    case ActionTypes.SET_ESTADOS_PRACTICA:
      return {
        ...state,
        estadosPractica: action.payload,
      };

    case ActionTypes.SET_TIPOS_SERVICIO:
      return {
        ...state,
        tiposServicio: action.payload,
      };

    case ActionTypes.SET_SOCIEDADES:
      return {
        ...state,
        sociedades: action.payload,
      };

    case ActionTypes.SET_JORNADAS_USUARIO:
      return {
        ...state,
        jornadasUsuario: action.payload,
      };

    case ActionTypes.SET_ESTACIONES:
      return {
        ...state,
        estaciones: action.payload,
      };

    case ActionTypes.SET_TIPOS_PRACTICA:
      return {
        ...state,
        tiposPractica: action.payload,
      };
    case ActionTypes.SET_USER_INFO:
      return {
        ...state,
        infoUser: action.payload,
      };

    // Requests statuses
    case ActionTypes.SET_POST_ANULAR_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        postAnularPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_POST_RECHAZAR_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        postRechazarPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_POST_RECLAMAR_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        postReclamarPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_POST_VALIDAR_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        postValidarPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_FILTER_CURSO_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getFilterCursoPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_FORMADOR_CURSO_REQUEST_STATUS:
      return {
        ...state,
        getFilterFormadorCursoRequestStatus: action.payload,
      };  

    case ActionTypes.SET_GET_FILTER_ALUMNO_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getFilterAlumnoPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_ESTADOS_CURSOS_REQUEST_STATUS:
      return {
        ...state,
        getEstadosCursosRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_FECHA_MINIMA_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getFechaMinimaPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_FECHA_MAXIMA_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getFechaMaximaPracticaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_PRACTICAS_SELECCIONADA_REQUEST_STATUS:
      return {
        ...state,
        getPracticaSeleccionadaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_PRACTICAS_BY_JORNADA_REQUEST_STATUS:
      return {
        ...state,
        getPracticasByJornadaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_CURSOS_ACTIVOS_JORNADA_REQUEST_STATUS:
      return {
        ...state,
        getCursosActivosJornadaRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_INSTRUCTORES_PRACTICAS_REQUEST_STATUS:
      return {
        ...state,
        getInstructoresPracticasRequestStatus: action.payload,
      };

    case ActionTypes.SET_CREAR_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        crearPracticaRequestStatus: action.payload,
      };
    case ActionTypes.SET_GET_PRACTICAS_COUNT_REQUEST_STATUS:
      return {
        ...state,
        getPracticasCountRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_PRACTICAS_REQUEST_STATUS:
      return {
        ...state,
        getPracticasRequestStatus: action.payload,
      };
    case ActionTypes.SET_GET_PRACTICAS_REQUEST_STATUS_LOADING:
      return {
        ...state,
        getPracticasRequestStatus: {
          status: RequestStatusTypes.Loading,
        },
      };

    case ActionTypes.SET_GET_ESTADOS_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getEstadosPracticaRequestStatus: action.payload,
      };
    case ActionTypes.SET_GET_AUDIT_PRACTICES_REQUEST_STATUS_LOADING:
      return {
        ...state,
        getEstadosPracticaRequestStatus: {
          status: RequestStatusTypes.Loading,
        },
      };

    case ActionTypes.SET_GET_TIPO_SERVICIO_REQUEST_STATUS:
      return {
        ...state,
        getTipoServicioRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_SOCIEDADES_REQUEST_STATUS:
      return {
        ...state,
        getSociedadesRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_JORNADAS_USUARIO_REQUEST_STATUS:
      return {
        ...state,
        getJornadasUsuarioRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_ESTACIONES_REQUEST_STATUS:
      return {
        ...state,
        getEstacionesRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_TIPOS_PRACTICA_REQUEST_STATUS:
      return {
        ...state,
        getTiposPracticaRequestStatus: action.payload,
      };
    case ActionTypes.SET_SORTING_SORT:
      return {
        ...state,
        ascDesc: action.payload,
      };
    case ActionTypes.SET_SORTING:
      return {
        ...state,
        orden: action.payload,
      };
    case ActionTypes.RESET_SORT:
      return { ...state, orden: '', ascDesc: '' };
    case ActionTypes.SET_SORT:
      return {
        ...state,
        orden: action.payload.sortBy,
        ascDesc: action.payload.sortingSort,
      };
    case ActionTypes.SET_PRACTICAS_2:
      return {
        ...state,
        practicasList: action.payload,
      };
    case ActionTypes.SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
      };
    case ActionTypes.SET_PRACTICAS_COUNT_2:
      return {
        ...state,
        practicasListCount: action.payload,
      };
    case ActionTypes.REMOVE_PRACTICAS_FILTER:
      return {
        ...state,
        sociedades: [],
        instructoresPracticas: [],
        cursosPractica: [],
        formadoresCursos: [],
        alumnosPractica: [],
        estadosPractica: [],
      };
    default:
      return state;
  }
};

const persistConfig = {
  key: 'practicas',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    'postAnularPracticaRequestStatus',
    'postRechazarPracticaRequestStatus',
    'postReclamarPracticaRequestStatus',
    'postValidarPracticaRequestStatus',
    'getFilterCursoPracticaRequestStatus',
    'getFilterFormadorCursoRequestStatus',
    'getFilterAlumnoPracticaRequestStatus',
    'getEstadosCursosRequestStatus',
    'getFechaMinimaPracticaRequestStatus',
    'getPracticaSeleccionadaRequestStatus',
    'getCursosActivosJornadaRequestStatus',
    'getInstructoresPracticasRequestStatus',
    'crearPracticaRequestStatus',
    'getPracticasCountRequestStatus',
    'getPracticasRequestStatus',
    'getPracticasByJornadaRequestStatus',
    'getEstadosPracticaRequestStatus',
    'getTipoServicioRequestStatus',
    'getSociedadesRequestStatus',
    'getJornadasUsuarioRequestStatus',
    'getEstacionesRequestStatus',
    'getTiposPracticaRequestStatus',
    'todasPracticasAuditoria',
  ],
};

export default persistReducer(persistConfig, reducer);
